import {ApplicationType} from 'ApplicationEntry/models/ApplicationType';
import {Disability, matchDisabilityByType} from 'ApplicationEntry/models/ProductsRiders/Disability/Disability';
import * as G from 'ApplicationEntry/models/ProductsRiders/Disability/GroupDisability';
import * as NY from 'ApplicationEntry/models/ProductsRiders/Disability/NewYorkDisability';
import * as O from 'ApplicationEntry/models/ProductsRiders/Disability/OrdinaryDisability';
import {Async, Loading} from 'Core/models/Async';
import {NonEmptyString} from 'Core/models/EmptyString';
import {Plan} from 'ApplicationEntry/models/ProductsRiders/PlanModel';
import {createAction} from 'Shared/utilities/actionCreator';
import {reverseEnum} from 'Shared/utilities/enumUtility';
import {SalaryDeductionOccupationClassModel} from 'ApplicationEntry/models/ProductsRiders/SalaryDeductionOccupationClassModel';

export enum DisabilityActionType {
  CHANGE_PLAN_TYPE = 'disability/CHANGE_PLAN_TYPE',
  CHANGE_PREMIUM = 'disability/CHANGE_PREMIUM',
  CHANGE_CALCULATED_PREMIUM = 'disability/CHANGE_CALCULATED_PREMIUM',
  CHANGE_CWA = 'disability/CHANGE_CWA',
  CHANGE_ISSUE_TYPE = 'disability/CHANGE_ISSUE_TYPE',
  CHANGE_RIDER_MONTHLY = 'disability/CHANGE_RIDER_MONTHLY',
  CHANGE_MONTHLY_SALARY = 'disability/CHANGE_MONTHLY_SALARY',
  CHANGE_TYPE = 'disability/CHANGE_TYPE',
  CHANGE_ACCIDENT = 'disability/CHANGE_ACCIDENT',
  CHANGE_SICKNESS = 'disability/CHANGE_SICKNESS',
  CHANGE_OCC_CLASS = 'disability/CHANGE_OCC_CLASS',
  CHANGE_ACCIDENT_RIDER_UNIT = 'disability/CHANGE_ACCIDENT_RIDER_UNIT',
  CHANGE_BENEFIT_PERIOD = 'disability/CHANGE_BENEFIT_PERIOD',
  CHANGE_MENTAL_NERVOUS_RIDER = 'disability/CHANGE_MENTAL_NERVOUS_RIDER',
  CHANGE_SECTION125 = 'disability/CHANGE_SECTION125',
  CHANGE_ON_JOB_RIDER = 'disability/CHANGE_ON_JOB_RIDER',
  CHANGE_BENEFIT_MONTHLY = 'disability/CHANGE_BENEFIT_MONTHLY',
  CHANGE_PACKAGE_SOURCE = 'disability/CHANGE_PACKAGE_SOURCE',
  CHANGE_SITUS_STATE = 'disability/CHANGE_SITUS_STATE',
  CHANGE_REPLACEMENT = 'disability/CHANGE_REPLACEMENT',
  CHANGE_POLICY_NUMBER = 'disability/CHANGE_POLICY_NUMBER',
  CHANGE_GCROPR_RIDER = 'disability/CHANGE_GCROPR_RIDER',
  CHANGE_OADR1_RIDER = 'disability/CHANGE_OADR1_RIDER',
  CHANGE_FMDR1_RIDER = 'disability/CHANGE_FMDR1_RIDER',
  CHANGE_IBDR1_RIDER = 'disability/CHANGE_IBDR1_RIDER',
  CHANGE_SADR_RIDER = 'disability/CHANGE_SADR_RIDER',
  CHANGE_J_STAMP = 'disability/CHANGE_J_STAMP',
  CHANGE_JET_ISSUE = 'disability/CHANGE_JET_ISSUE',
  CHANGE_RIDER_TYPE = 'disability/CHANGE_RIDER_TYPE',
  CHANGE_ADD_RIDER = 'disability/CHANGE_ADD_RIDER',
  GET_PLAN_TYPE = 'disability/GET_PLAN_TYPE',
  GET_PLAN = 'disability/GET_PLAN',
  CHANGE_PLAN_TYPE_API = 'disability/CHANGE_PLAN_TYPE_API',
  CHANGE_PLAN_API = 'disability/CHANGE_PLAN_API',
  GET_TYPE = 'disability/GET_TYPE',
  CHANGE_TYPE_API = 'disability/CHANGE_TYPE_API',
  GET_ACCIDENT_RIDER_UNIT = 'disability/GET_ACCIDENT_RIDER_UNIT',
  CHANGE_ACCIDENT_RIDER_UNIT_API = 'disability/CHANGE_ACCIDENT_RIDER_UNIT_API',
  GET_ACCIDENT = 'disability/GET_ACCIDENT',
  CHANGE_ACCIDENT_API = 'disability/CHANGE_ACCIDENT_API',
  GET_SICKNESS = 'disability/GET_SICKNESS',
  CHANGE_SICKNESS_API = 'disability/CHANGE_SICKNESS_API',
  GET_BENEFIT_PERIOD = 'disability/GET_BENEFIT_PERIOD',
  CHANGE_BENEFIT_PERIOD_API = 'disability/CHANGE_BENEFIT_PERIOD_API',
  GET_RIDER_TYPE = 'disability/GET_RIDER_TYPE',
  CHANGE_RIDER_TYPE_API = 'disability/CHANGE_RIDER_TYPE_API',
  GET_OCC_CLASS = 'disability/GET_OCC_CLASS',
  GET_SALD_OCC_CLASS = 'disability/GET_SALD_OCC_CLASS',
  CHANGE_OCC_CLASS_API = 'disability/CHANGE_OCC_CLASS_API',
  CHANGE_SALD_OCC_CLASS_API = 'disability/CHANGE_SALD_OCC_CLASS_API',
  GET_PACKAGE_SOURCE_LIST = 'disability/GET_PACKAGE_SOURCE_LIST',
  CHANGE_PACKAGE_SOURCE_LIST_API = 'disability/CHANGE_PACKAGE_SOURCE_LIST_API',
  CHANGE_PLAN = 'disability/CHANGE_PLAN',
  CLEAR_DISABILITY = 'disability/CLEAR_DISABILITY',
  CHANGE_PRODUCT = 'disability/CHANGE_PRODUCT',
  CHANGE_SALD_OCC_CLASS = 'disability/CHANGE_SALD_OCC_CLASS',
}

export const isDisabilityAction = (action: any): action is DisabilityAction =>
  action.type in reverseEnum(DisabilityActionType);

export const changePlan = (plan: string) => createAction(DisabilityActionType.CHANGE_PLAN, {plan});
export const changeIssueType = (issueType: string) => createAction(DisabilityActionType.CHANGE_ISSUE_TYPE, {issueType});
export const changePremium = (premium: string) => createAction(DisabilityActionType.CHANGE_PREMIUM, {premium});
export const changeCalculatedPremium = (calculatedPremium: string) =>
  createAction(DisabilityActionType.CHANGE_CALCULATED_PREMIUM, {calculatedPremium});
export const changeCWA = (cwa: string) => createAction(DisabilityActionType.CHANGE_CWA, {cwa});
export const changeOnJobMonthlyRider = (monthlyrider: string) =>
  createAction(DisabilityActionType.CHANGE_RIDER_MONTHLY, {monthlyrider});
export const changeMonthlySalary = (monthlySalary: string) =>
  createAction(DisabilityActionType.CHANGE_MONTHLY_SALARY, {monthlySalary});
export const changeType = (type: string) => createAction(DisabilityActionType.CHANGE_TYPE, {type});
export const changeAccident = (accident: string) => createAction(DisabilityActionType.CHANGE_ACCIDENT, {accident});
export const changeSickness = (sickness: string) => createAction(DisabilityActionType.CHANGE_SICKNESS, {sickness});
export const changeOccClass = (occ: string) => createAction(DisabilityActionType.CHANGE_OCC_CLASS, {occ});
export const changeAccidentRiderUnit = (riderUnit: number) =>
  createAction(DisabilityActionType.CHANGE_ACCIDENT_RIDER_UNIT, {riderUnit});
export const changeBenefitPeriod = (benefit: string) =>
  createAction(DisabilityActionType.CHANGE_BENEFIT_PERIOD, {benefit});
export const changeMentalNervousRider = (rider: boolean) =>
  createAction(DisabilityActionType.CHANGE_MENTAL_NERVOUS_RIDER, {rider});
export const changeOnJobRider = (rider: boolean) => createAction(DisabilityActionType.CHANGE_ON_JOB_RIDER, {rider});
export const changeSection125 = (section125: boolean) =>
  createAction(DisabilityActionType.CHANGE_SECTION125, {section125});
export const changeBenefitMonthly = (monthlyBenefit: string) =>
  createAction(DisabilityActionType.CHANGE_BENEFIT_MONTHLY, {monthlyBenefit});
export const changeRiderType = (riderType: string) => createAction(DisabilityActionType.CHANGE_RIDER_TYPE, {riderType});
export const changeAddRider = (addRider: boolean) => createAction(DisabilityActionType.CHANGE_ADD_RIDER, {addRider});
export const changePackageSource = (packageSource: string) =>
  createAction(DisabilityActionType.CHANGE_PACKAGE_SOURCE, {packageSource});
export const changeGCROPRRider = (rider: boolean) => createAction(DisabilityActionType.CHANGE_GCROPR_RIDER, {rider});
export const changeOADR1Rider = (rider: boolean) => createAction(DisabilityActionType.CHANGE_OADR1_RIDER, {rider});
export const changeFMDR1Rider = (rider: boolean) => createAction(DisabilityActionType.CHANGE_FMDR1_RIDER, {rider});
export const changeIBDR1Rider = (rider: boolean) => createAction(DisabilityActionType.CHANGE_IBDR1_RIDER, {rider});
export const changeSADRRider = (rider: boolean) => createAction(DisabilityActionType.CHANGE_SADR_RIDER, {rider});
export const changeJStamp = (jStamp: boolean) => createAction(DisabilityActionType.CHANGE_J_STAMP, {jStamp});
export const changeSitusState = (situsState: string) =>
  createAction(DisabilityActionType.CHANGE_SITUS_STATE, {situsState});
export const changeReplacement = (replacement: boolean) =>
  createAction(DisabilityActionType.CHANGE_REPLACEMENT, {replacement});
export const changePolicyNumber = (policyNumber: string) =>
  createAction(DisabilityActionType.CHANGE_POLICY_NUMBER, {policyNumber});
export const changeJetIssue = (jetIssue: boolean) => createAction(DisabilityActionType.CHANGE_JET_ISSUE, {jetIssue});

export const getPlanType = (applicationType: ApplicationType, family: string) =>
  createAction(DisabilityActionType.GET_PLAN_TYPE, {applicationType, family});
export const getType = (applicationType: ApplicationType, family: string, planType: string) =>
  createAction(DisabilityActionType.GET_TYPE, {applicationType, family, planType});
export const getAccident = (applicationType: ApplicationType, family: string) =>
  createAction(DisabilityActionType.GET_ACCIDENT, {applicationType, family});
export const getSickness = (applicationType: ApplicationType, family: string) =>
  createAction(DisabilityActionType.GET_SICKNESS, {applicationType, family});
export const getBenefitPeriod = (applicationType: ApplicationType, family: string, type: string, planType: string) =>
  createAction(DisabilityActionType.GET_BENEFIT_PERIOD, {applicationType, family, type, planType});
export const getAccidentRiderUnits = (applicationType: ApplicationType, family: string) =>
  createAction(DisabilityActionType.GET_ACCIDENT_RIDER_UNIT, {applicationType, family});
export const getRiderType = (applicationType: ApplicationType, family: string) =>
  createAction(DisabilityActionType.GET_RIDER_TYPE, {applicationType, family});
export const getOccClass = (applicationType: ApplicationType, family: string) =>
  createAction(DisabilityActionType.GET_OCC_CLASS, {applicationType, family});
export const getSaldOccClass = (caseNumber: string, plan: Plan) =>
  createAction(DisabilityActionType.GET_SALD_OCC_CLASS, {caseNumber, plan});
export const getPackageSourceList = (caseNumber: string, planCode: string) =>
  createAction(DisabilityActionType.GET_PACKAGE_SOURCE_LIST, {caseNumber, planCode});
export const changePlanTypeApi = (products: Async<string[]>) =>
  createAction(DisabilityActionType.CHANGE_PLAN_TYPE_API, {products});
export const changeTypeApi = (types: Async<string[]>) => createAction(DisabilityActionType.CHANGE_TYPE_API, {types});
export const changeAccidentApi = (accProducts: Async<string[]>) =>
  createAction(DisabilityActionType.CHANGE_ACCIDENT_API, {accProducts});
export const changeSicknessApi = (sicknessProducts: Async<string[]>) =>
  createAction(DisabilityActionType.CHANGE_SICKNESS_API, {sicknessProducts});
export const changeBenefitPeriodApi = (benefitPeriodList: Async<number[]>) =>
  createAction(DisabilityActionType.CHANGE_BENEFIT_PERIOD_API, {benefitPeriodList});
export const changeAccidentRiderUnitsApi = (accidentRiderUnitsList: Async<number[]>) =>
  createAction(DisabilityActionType.CHANGE_ACCIDENT_RIDER_UNIT_API, {accidentRiderUnitsList});
export const changeRiderTypeApi = (riderTypeList: Async<string[]>) =>
  createAction(DisabilityActionType.CHANGE_RIDER_TYPE_API, {riderTypeList});
export const changeOccClassApi = (occClasssList: Async<string[]>) =>
  createAction(DisabilityActionType.CHANGE_OCC_CLASS_API, {occClasssList});
export const changeSaldOccClassApi = (saldOccClassList: Async<string[]>) =>
  createAction(DisabilityActionType.CHANGE_SALD_OCC_CLASS_API, {saldOccClassList});
export const changePackageSourceApi = (packageSourceList: Async<object[]>) =>
  createAction(DisabilityActionType.CHANGE_PACKAGE_SOURCE_LIST_API, {packageSourceList});
export const clearDisability = () => createAction(DisabilityActionType.CLEAR_DISABILITY);
export const changeProduct = (product: string) => createAction(DisabilityActionType.CHANGE_PRODUCT, {product});
export const changeSaldOccClass = (occClass: SalaryDeductionOccupationClassModel) =>
  createAction(DisabilityActionType.CHANGE_SALD_OCC_CLASS, {occClass});

export type DisabilityAction =
  | ReturnType<typeof changePlan>
  | ReturnType<typeof changePremium>
  | ReturnType<typeof changeCalculatedPremium>
  | ReturnType<typeof changeCWA>
  | ReturnType<typeof changeIssueType>
  | ReturnType<typeof changeOnJobMonthlyRider>
  | ReturnType<typeof changeType>
  | ReturnType<typeof changeSection125>
  | ReturnType<typeof changeAccident>
  | ReturnType<typeof changeSickness>
  | ReturnType<typeof changeOccClass>
  | ReturnType<typeof changeSaldOccClass>
  | ReturnType<typeof changeAccidentRiderUnit>
  | ReturnType<typeof changeBenefitPeriod>
  | ReturnType<typeof changeMentalNervousRider>
  | ReturnType<typeof changeOnJobRider>
  | ReturnType<typeof changeMonthlySalary>
  | ReturnType<typeof changeGCROPRRider>
  | ReturnType<typeof changeOADR1Rider>
  | ReturnType<typeof changeFMDR1Rider>
  | ReturnType<typeof changeIBDR1Rider>
  | ReturnType<typeof changeSADRRider>
  | ReturnType<typeof changeReplacement>
  | ReturnType<typeof changePolicyNumber>
  | ReturnType<typeof changeBenefitMonthly>
  | ReturnType<typeof changePackageSource>
  | ReturnType<typeof changeSitusState>
  | ReturnType<typeof changeJStamp>
  | ReturnType<typeof changeRiderType>
  | ReturnType<typeof changeAddRider>
  | ReturnType<typeof getPlanType>
  | ReturnType<typeof getType>
  | ReturnType<typeof getAccident>
  | ReturnType<typeof getSickness>
  | ReturnType<typeof getBenefitPeriod>
  | ReturnType<typeof getAccidentRiderUnits>
  | ReturnType<typeof getPackageSourceList>
  | ReturnType<typeof getRiderType>
  | ReturnType<typeof getOccClass>
  | ReturnType<typeof getSaldOccClass>
  | ReturnType<typeof changePlanTypeApi>
  | ReturnType<typeof changeTypeApi>
  | ReturnType<typeof changeAccidentApi>
  | ReturnType<typeof changeSicknessApi>
  | ReturnType<typeof changeBenefitPeriodApi>
  | ReturnType<typeof changeAccidentRiderUnitsApi>
  | ReturnType<typeof changeRiderTypeApi>
  | ReturnType<typeof changePackageSourceApi>
  | ReturnType<typeof changeOccClassApi>
  | ReturnType<typeof changeSaldOccClassApi>
  | ReturnType<typeof changeJetIssue>
  | ReturnType<typeof clearDisability>
  | ReturnType<typeof changeProduct>;

type DisabilityState = Disability;

export default (state: DisabilityState, action: DisabilityAction): DisabilityState => {
  switch (action.type) {
    case DisabilityActionType.CHANGE_PLAN:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changePlan(action.payload.plan),
        Group: G.changePlan(action.payload.plan),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_PREMIUM:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changePremium(action.payload.premium),
        Group: G.changePremium(action.payload.premium),
        NewYork: NY.changePremium(action.payload.premium),
      })(state);
    case DisabilityActionType.CHANGE_CALCULATED_PREMIUM:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeCalculatedPremium(action.payload.calculatedPremium),
        Group: G.changeCalculatedPremium(action.payload.calculatedPremium),
        NewYork: NY.changeCalculatedPremium(action.payload.calculatedPremium),
      })(state);
    case DisabilityActionType.CHANGE_CWA:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeCWA(action.payload.cwa),
        Group: G.changeCWA(action.payload.cwa),
        NewYork: NY.changeCWA(action.payload.cwa),
      })(state);
    case DisabilityActionType.CHANGE_ISSUE_TYPE:
      return matchDisabilityByType<Disability>({
        Group: G.changeIssueType(action.payload.issueType),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_PACKAGE_SOURCE:
      return matchDisabilityByType<Disability>({
        Group: G.changePackageSource(action.payload.packageSource),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_RIDER_MONTHLY:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeOnJobMonthlyRider(action.payload.monthlyrider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_TYPE:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeType(action.payload.type),
        Group: G.changeType(action.payload.type),
        NewYork: NY.changeType(action.payload.type),
      })(state);
    case DisabilityActionType.CHANGE_SECTION125:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeSection125(action.payload.section125),
        Group: G.changeSection125(action.payload.section125),
        NewYork: NY.changeSection125(action.payload.section125),
      })(state);
    case DisabilityActionType.CHANGE_ACCIDENT:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeAccident(action.payload.accident),
        Group: G.changeAccident(action.payload.accident),
        NewYork: NY.changeAccident(action.payload.accident),
      })(state);
    case DisabilityActionType.CHANGE_SICKNESS:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeSickness(action.payload.sickness),
        Group: G.changeSickness(action.payload.sickness),
        NewYork: NY.changeSickness(action.payload.sickness),
      })(state);
    case DisabilityActionType.CHANGE_OCC_CLASS:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeOccClass(action.payload.occ),
        NewYork: NY.changeOccClass(action.payload.occ),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_SALD_OCC_CLASS:
      return matchDisabilityByType<Disability>({
        Group: G.changeSaldOccClass(action.payload.occClass),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_SALD_OCC_CLASS:
      return matchDisabilityByType<Disability>({
        Group: G.changeSaldOccClass(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_ACCIDENT_RIDER_UNIT:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeAccRiderUnit(action.payload.riderUnit),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_BENEFIT_PERIOD:
      return matchDisabilityByType<Disability>({
        Group: G.changeBenefitPeriod(action.payload.benefit),
        Ordinary: O.changeBenefitPeriod(action.payload.benefit),
        NewYork: NY.changeBenefitPeriod(action.payload.benefit),
      })(state);
    case DisabilityActionType.CHANGE_MENTAL_NERVOUS_RIDER:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeMentalNervousRider(action.payload.rider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_GCROPR_RIDER:
      return matchDisabilityByType<Disability>({
        Group: G.changeGcropr(action.payload.rider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_OADR1_RIDER:
      return matchDisabilityByType<Disability>({
        Group: G.changeOadr1(action.payload.rider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_FMDR1_RIDER:
      return matchDisabilityByType<Disability>({
        Group: G.changeFmdr1(action.payload.rider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_IBDR1_RIDER:
      return matchDisabilityByType<Disability>({
        Group: G.changeIbdr1(action.payload.rider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_SADR_RIDER:
      return matchDisabilityByType<Disability>({
        Group: G.changeSadr(action.payload.rider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_J_STAMP:
      return matchDisabilityByType<Disability>({
        Group: G.changeJStamp(action.payload.jStamp),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_REPLACEMENT:
      return matchDisabilityByType<Disability>({
        Group: G.changeReplacement(action.payload.replacement),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_POLICY_NUMBER:
      return matchDisabilityByType<Disability>({
        Group: G.changePolicyNumber(NonEmptyString.create(action.payload.policyNumber)),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_SITUS_STATE:
      return matchDisabilityByType<Disability>({
        Group: G.changeSitusState(action.payload.situsState),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_ON_JOB_RIDER:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeOnJobRider(action.payload.rider),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_MONTHLY_SALARY:
      return matchDisabilityByType<Disability>({
        Group: G.changeMonthlySalary(action.payload.monthlySalary),
        Ordinary: O.changeMonthlySalary(action.payload.monthlySalary),
        NewYork: NY.changeMonthlySalary(action.payload.monthlySalary),
      })(state);
    case DisabilityActionType.CHANGE_BENEFIT_MONTHLY:
      return matchDisabilityByType<Disability>({
        Group: G.changeBenefitMonthly(action.payload.monthlyBenefit),
        Ordinary: O.changeBenefitMonthly(action.payload.monthlyBenefit),
        NewYork: NY.changeBenefitMonthly(action.payload.monthlyBenefit),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_RIDER_TYPE:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeRiderType(action.payload.riderType),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_ADD_RIDER:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeAddRider(action.payload.addRider),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_PLAN_TYPE:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changePlanList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_TYPE:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeTypeList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_ACCIDENT:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeAccidentList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_SICKNESS:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeSicknessList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_BENEFIT_PERIOD:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeBenefitPeriodList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_ACCIDENT_RIDER_UNIT:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeAccRiderUnitList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_RIDER_TYPE:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeRiderTypeList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_OCC_CLASS:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeOccClassList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.GET_PACKAGE_SOURCE_LIST:
      return matchDisabilityByType<Disability>({
        Group: G.changePackageSourceList(new Loading()),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_PLAN_TYPE_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changePlanList(action.payload.products),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_TYPE_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeTypeList(action.payload.types),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_ACCIDENT_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeAccidentList(action.payload.accProducts),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_SICKNESS_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeSicknessList(action.payload.sicknessProducts),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_BENEFIT_PERIOD_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeBenefitPeriodList(action.payload.benefitPeriodList),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_ACCIDENT_RIDER_UNIT_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeAccRiderUnitList(action.payload.accidentRiderUnitsList),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_RIDER_TYPE_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeRiderTypeList(action.payload.riderTypeList),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_OCC_CLASS_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeOccClassList(action.payload.occClasssList),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_SALD_OCC_CLASS_API:
      return matchDisabilityByType<Disability>({
        Ordinary: O.changeSaldOccClassList(action.payload.saldOccClassList),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_PACKAGE_SOURCE_LIST_API:
      return matchDisabilityByType<Disability>({
        Group: G.changePackageSourceList(action.payload.packageSourceList),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_JET_ISSUE:
      return matchDisabilityByType<Disability>({
        NewYork: NY.changeJetIssue(action.payload.jetIssue),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_PLAN:
      return matchDisabilityByType<Disability>({
        NewYork: NY.changePlan(action.payload.plan),
        _: () => state,
      })(state);
    case DisabilityActionType.CHANGE_PRODUCT:
      return matchDisabilityByType<Disability>({
        NewYork: NY.changeProduct(action.payload.product),
        _: () => state,
      })(state);
    case DisabilityActionType.CLEAR_DISABILITY: {
      if (state.key === 'InvalidNewYorkDisability' || state.key === 'ValidNewYorkDisability') {
        return NY.EmptyNewYorkDisability;
      }

      return state;
    }
    default:
      return state;
  }
};
